import type { Context } from 'react';
import { createContext } from 'react';

import { useMetrics } from '@cognite/metrics';

export interface UseChecklistItemsUpsertMutationContextInterface {
  useMetrics: (
    ...args: Parameters<typeof useMetrics>
  ) => Pick<ReturnType<typeof useMetrics>, 'track'>;
}

let context: Context<UseChecklistItemsUpsertMutationContextInterface>;

export const getChecklistItemsUpsertMutationContext = () => {
  if (!context) {
    context = createContext<UseChecklistItemsUpsertMutationContextInterface>({
      useMetrics,
    });
  }
  return context;
};
